import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = ["Cloud Native", "DevOps", "Generative AI", "Platform Engineering", "Microservices", "GitOps", "SRE"];

export default function EditorialMarquee() {
  return (
    <section data-testid="marquee" className="py-8 md:py-12 border-b border-line overflow-hidden">
      <Marquee speed={38} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center gap-6 md:gap-10 pr-6 md:pr-10">
            <span className="font-heading font-black text-4xl md:text-6xl tracking-tighter stroke-text">
              {w}
            </span>
            <span className="h-2.5 w-2.5 rounded-full bg-brand/70" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
